import { Input } from 'alurkerja-ui'
import { stringToTitleCase } from '@/utils/functions/stringToTitleCase'
import React from 'react'

type EditLabelProps = {
  index: number
  element: string
  currentElementState: any
  setCurrentElementState: React.Dispatch<any>
}

export default function EditOptionsSwitch(props: EditLabelProps) {
  const { element, currentElementState, setCurrentElementState } = props

  return (
    <>
      <div className="py-2 px-3 space-y-1">
        <span className="font-semibold">{stringToTitleCase(element)}</span>
        {currentElementState?.[element]?.map((option: { value: boolean; label: string }, index: number) => {
          return (
            <div key={index} className="bg-slate-50 rounded-md overflow-hidden mb-2">
              <div className="py-1">
                <div className="grid grid-cols-4 px-4 items-center mb-1">
                  <label htmlFor={'label' + index} className="text-sm">
                    label
                  </label>
                  <Input
                    id={'label' + index}
                    className="w-full h-8 text-sm col-span-3"
                    type="text"
                    size="xs"
                    value={option.label}
                    onChange={(e) => {
                      setCurrentElementState((prevState: any) => {
                        const newArray = [...prevState[element]]
                        const index = newArray.findIndex((opt) => opt.label === option.label)
                        if (index === -1) return prevState // If not found, return previous state
                        newArray[index] = {
                          ...newArray[index],
                          label: e.target.value,
                        }
                        return {
                          ...prevState,
                          [element]: newArray,
                        }
                      })
                    }}
                  />
                </div>
                <div className="grid grid-cols-4 px-4 items-center">
                  <label htmlFor={'value' + index} className="text-sm">
                    value
                  </label>
                  <Input
                    id={'value' + index}
                    className="w-full h-8 text-sm col-span-3"
                    type="text"
                    size="xs"
                    value={String(option.value)}
                    disabled
                  />
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </>
  )
}
